import script from "./PortfolioNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortfolioNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./PortfolioNavigation.vue?vue&type=style&index=0&id=52744854&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52744854"]])

export default __exports__